var _circle, _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptySubscriptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 180,
    viewBox: "0 0 252 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 90,
    r: 90,
    fill: "#C6E7F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_2049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3793 69.0001H239.621C241.313 69.0001 242.935 69.6774 244.132 70.883C245.328 72.0886 246 73.7237 246 75.4287V107.572C246 109.277 245.328 110.912 244.132 112.117C242.935 113.323 241.313 114 239.621 114H67.3793C65.6874 114 64.0648 113.323 62.8685 112.117C61.6721 110.912 61 109.277 61 107.572V75.4287C61 73.7237 61.6721 72.0886 62.8685 70.883C64.0648 69.6774 65.6874 69.0001 67.3793 69.0001V69.0001Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.688 79.7144H129.477C127.361 79.7144 125.645 81.4413 125.645 83.5716C125.645 85.7018 127.361 87.4287 129.477 87.4287H162.688C164.805 87.4287 166.52 85.7018 166.52 83.5716C166.52 81.4413 164.805 79.7144 162.688 79.7144Z",
    fill: "#40B0D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.681 96.4286H129.477C127.361 96.4286 125.645 98.1556 125.645 100.286C125.645 102.416 127.361 104.143 129.477 104.143H185.681C187.797 104.143 189.513 102.416 189.513 100.286C189.513 98.1556 187.797 96.4286 185.681 96.4286Z",
    fill: "#40B0D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98 103.714C104.627 103.714 110 98.3418 110 91.7144C110 85.0869 104.627 79.7144 98 79.7144C91.3726 79.7144 86 85.0869 86 91.7144C86 98.3418 91.3726 103.714 98 103.714Z",
    fill: "#3AF2AE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17_2049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 124H184.621C186.313 124 187.935 124.677 189.132 125.883C190.328 127.088 191 128.724 191 130.429V162.571C191 164.276 190.328 165.912 189.132 167.117C187.935 168.323 186.313 169 184.621 169H12.3793C10.6874 169 9.06481 168.323 7.86846 167.117C6.6721 165.912 6 164.276 6 162.571V130.429C6 128.724 6.6721 127.088 7.86846 125.883C9.06481 124.677 10.6874 124 12.3793 124V124Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.688 134.714H74.4771C72.3607 134.714 70.645 136.441 70.645 138.571C70.645 140.702 72.3607 142.429 74.4771 142.429H107.688C109.805 142.429 111.52 140.702 111.52 138.571C111.52 136.441 109.805 134.714 107.688 134.714Z",
    fill: "#40B0D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.681 151.429H74.4773C72.3609 151.429 70.6453 153.155 70.6453 155.286C70.6453 157.416 72.3609 159.143 74.4773 159.143H130.681C132.797 159.143 134.513 157.416 134.513 155.286C134.513 153.155 132.797 151.429 130.681 151.429Z",
    fill: "#40B0D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 158.714C49.6274 158.714 55 153.342 55 146.714C55 140.087 49.6274 134.714 43 134.714C36.3726 134.714 31 140.087 31 146.714C31 153.342 36.3726 158.714 43 158.714Z",
    fill: "#3AF2AE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_17_2049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 14H184.621C186.313 14 187.935 14.6773 189.132 15.8829C190.328 17.0885 191 18.7236 191 20.4286V52.5714C191 54.2764 190.328 55.9115 189.132 57.1171C187.935 58.3227 186.313 59 184.621 59H12.3793C10.6874 59 9.06481 58.3227 7.86846 57.1171C6.6721 55.9115 6 54.2764 6 52.5714V20.4286C6 18.7236 6.6721 17.0885 7.86846 15.8829C9.06481 14.6773 10.6874 14 12.3793 14V14Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.688 24.7143H74.4771C72.3607 24.7143 70.645 26.4412 70.645 28.5714C70.645 30.7017 72.3607 32.4286 74.4771 32.4286H107.688C109.805 32.4286 111.52 30.7017 111.52 28.5714C111.52 26.4412 109.805 24.7143 107.688 24.7143Z",
    fill: "#40B0D5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.681 41.4285H74.4773C72.3609 41.4285 70.6453 43.1554 70.6453 45.2857C70.6453 47.4159 72.3609 49.1428 74.4773 49.1428H130.681C132.797 49.1428 134.513 47.4159 134.513 45.2857C134.513 43.1554 132.797 41.4285 130.681 41.4285Z",
    fill: "#40B0D5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48.7142C49.6274 48.7142 55 43.3417 55 36.7142C55 30.0868 49.6274 24.7142 43 24.7142C36.3726 24.7142 31 30.0868 31 36.7142C31 43.3417 36.3726 48.7142 43 48.7142Z",
    fill: "#3AF2AE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_2049",
    x: 55,
    y: 66.0001,
    width: 197,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_2049"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_2049",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17_2049",
    x: 0,
    y: 121,
    width: 197,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_2049"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_2049",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_17_2049",
    x: 0,
    y: 11,
    width: 197,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_2049"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_2049",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySubscriptions);
export default __webpack_public_path__ + "static/media/empty-subscriptions.b4edf5865d219a65ec3f824f91f1b87d.svg";
export { ForwardRef as ReactComponent };